import { useContext, useEffect } from 'react'
import { Select } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const RemoveEligibleElector = ({ confirm }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const formik = useFormik({
    initialValues: { reason: '' },
    validationSchema: Yup.object({ reason: Yup.string().required(t('admin.electorsList.validations.reasonRequired')) }),
    onSubmit: (values) => confirm(values.reason),
  })

  useEffect(() => {
    setHeaderLabel(t('admin.electorsList.eligible.removeEligible'))
    setBtns([
      { text: t('buttons.cancel'), variant: 'secondary', onClick: onClose, isCancel: true },
      { text: t('buttons.remove'), onClick: formik.handleSubmit },
    ])
  }, [])

  const options = [
    { value: 'deceased', label: t('admin.electorsList.eligible.removeReasonOptions.deceased') },
    { value: 'moved', label: t('admin.electorsList.eligible.removeReasonOptions.moved') },
    { value: 'other', label: t('admin.electorsList.eligible.removeReasonOptions.other') },
  ]

  return (
    <>
      <Select
        label={t('admin.electorsList.eligible.reason')}
        formik={formik}
        options={options}
        field='reason'
        value={formik.values.reason}
        isRequired={true}
        onChange={(item) => formik.setFieldValue('reason', item.value)}
      />
    </>
  )
}
